import React, { useState } from "react";
import { useSnapshot } from "valtio";
import { loginState, uiState } from "@/states.ts";
import { Button } from "@/components/ui/button.tsx";
import { ChangeEmailForm } from "@/pages/settings/ChangeEmailForm.tsx";
import { ChangePasswordForm } from "@/pages/settings/ChangePasswordForm.tsx";
import { regenerateApiToken } from "@/api/user_api.ts";

const AccountSettings: React.FC = (props) => {
	const snap = useSnapshot(loginState);
	const [openEmail, setOpenEmail] = useState(false);
	const [openPass, setOpenPass] = useState(false);

	const handleLogout = () => {
		loginState.token = undefined;
		localStorage.clear();
		window.location.href = import.meta.env.VITE_LANDING_URL;
	};

	const handleRegenerateToken = async () => {
		const res = await regenerateApiToken();
		if (res.ok && res.api_token) {
			loginState.user = {
				...loginState.user!,
				api_token: res.api_token,
			};
		}
	};

	const handleCopyToken = () => {
		if (snap.user?.api_token) {
			navigator.clipboard.writeText(snap.user.api_token);
		}
	};

	// TODO warn about must be online to change these || !loginState.user
	return (
		<div className={"w-full"}>
			<div className={"flex flex-col  p-4  w-full border-b"}>
				<div className={"flex justify-between items-center w-full"}>
					<h2>Email</h2>

					<Button
						variant={"outline"}
						onClick={() => setOpenEmail(!openEmail)}
					>
						Edit
					</Button>
				</div>
				{openEmail && <ChangeEmailForm />}
			</div>
			<div className={"flex flex-col p-4 w-full border-b"}>
				<div className={"flex justify-between items-center w-full"}>
					<h2>Password</h2>

					<Button
						variant={"outline"}
						onClick={() => setOpenPass(!openPass)}
					>
						Edit
					</Button>
				</div>
				{openPass && <ChangePasswordForm />}
			</div>
			<div className={"flex flex-col p-4 w-full border-b"}>
				<div className={"flex justify-between items-center w-full"}>
					<div className={"flex flex-col"}>
						<h2>API Token</h2>
						<p
							className={
								"text-sm text-muted-foreground break-all"
							}
						>
							{snap.user?.api_token
								? "Token available"
								: "No token generated"}
						</p>
					</div>

					<div className={"flex gap-2"}>
						{snap.user?.api_token && (
							<Button
								variant={"outline"}
								onClick={handleCopyToken}
							>
								Copy
							</Button>
						)}
						<Button
							variant={"outline"}
							onClick={handleRegenerateToken}
						>
							Regenerate
						</Button>
					</div>
				</div>
			</div>
			<div className={"flex justify-between p-4 items-center w-full border-b"}>
				<h2>Logout</h2>

				<Button variant={"outline"} onClick={handleLogout}>
					Logout
				</Button>
			</div>
			<div className={"flex justify-between p-4 items-center w-full"}>
				<h2>Delete Account</h2>

				<Button
					variant={"destructive"}
					onClick={() => (uiState.deleteAccount = true)}
				>
					Delete
				</Button>
			</div>
		</div>
	);
};

export { AccountSettings };
